<div class="d-flex w-100 justify-content-between align-items-center pt-4 mt-3 pb-5 title theme-interface">
  <h1 class="mb-0 font-size-popup-title theme-color-header font-weight-bold">
    {{'public.standalonepayment.paymentpage.selectSpecificDishes'|translate}}
  </h1>
  <span
    class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header cursor-pointer"
    (click)="onNoClick()">{{'public.global.close'
    | translate}}<i class="fas fa-times pl-2 theme-color-header"></i></span>
</div>
<div class="item-list theme-interface" *ngIf="data.order.orderItems">
  <ng-container *ngFor="let item of data.order.orderItems; last as isLastItem">
    <div class="item-wrapper d-flex flex-row mb-2 align-items-baseline"
      [ngClass]="(!shouldDisplayTotal() && isLastItem) ? 'no-border-bottom' : ''">
      <div class="mr-md-3 mr-2 mt-n-1 item-count-wrapper mt-n-1">
        <div class="qty d-flex font-size-primary font-weight-bold text-unselectable">
          <div class="decrement d-flex container-theme-light-icons" (click)="onDecreaseItemQty(item)">
            <i class="fa fa-minus m-auto" style="color: #0f0f0f;"></i>
          </div>
          <div class="value mx-md-3 mx-2 font-size-primary theme-color-text">{{this.selectedItems[item.uuid]}}</div>
          <div class="increment d-flex container-theme-light-icons" (click)="onIncreaseItemQty(item)">
            <i class="fa fa-plus m-auto" style="color: #0f0f0f;"></i>
          </div>
        </div>
      </div>
      <div class="qty theme-color-header font-weight-bold" *ngIf="item.hierarchyLevel === 'PARENT'">
        <span>{{item.quantity}}x</span>
      </div>
      <div class="item flex-fill mb-2" [ngClass]="item.hierarchyLevel === 'PARENT' ? 'ml-2' : ''">
        <div class="p-0 mb-0 item-name">
          <span class="theme-color-header font-weight-bold">{{item.itemName}}</span>
          <span class="text-nowrap" *ngIf="data.paymentData && item.offerPrice && isShowParentItemPrice(item)">(
            {{item.offerPrice | formatPrice:
            data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
            )</span>
        </div>
        <ng-container>
          <div class="item-specs p-0 mb-0" *ngIf="data.paymentData && item.discountValue">
            <span class="discount" *ngIf="item.discountType==='MONETARY'">{{'public.global.discount' | translate}}(- {{
              item.discountValue | formatPrice:
              data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
              )
            </span>
            <span class="discount" *ngIf="item.discountType==='PERCENTILE'">{{'public.global.discount' |translate}} (-
              {{
              item.offerPrice * item.discountValue / 100 | formatPrice:
              data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
              )
            </span>
            <span class="discount-percentage" *ngIf="item.discountType==='PERCENTILE'">-{{item.discountValue}}%</span>
          </div>
          <div class="item-specs p-0 mb-0" *ngIf="data.paymentData && item.childOrderItems?.length">
            <div *ngFor="let childItem of item.childOrderItems">
              <div>
                <span class="theme-color-header font-weight-bold">
                  {{childItem.quantity > 1 ? childItem.quantity + ' x' : ''}}
                  {{childItem.itemName}}
                </span>
                <span *ngIf="childItem.offerPrice">( {{childItem.offerPrice | formatPrice:
                  data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
                  )</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="price text-right font-weight-bold theme-color-header"
        *ngIf="item.hierarchyLevel === 'PARENT' || item.hierarchyLevel === 'RULE'">
        <div [ngClass]="{'striked':item.totalDiscountedPrice}"
          *ngIf="data.paymentData && item.totalNonDiscountedPrice !== 0">
          {{item.totalNonDiscountedPrice | formatPrice:
          data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}</div>
        <div *ngIf="data.paymentData && item.totalDiscountedPrice && item.totalDiscountedPrice > 0">
          {{item.totalDiscountedPrice | formatPrice:
          data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
        </div>
      </div>
    </div>
  </ng-container>
  <div class="cart-total-wrapper mb-3 d-flex flex-row font-weight-bold total-val pt-3"
    *ngIf="data.paymentData && shouldDisplayTotal()">
    <div class="total flex-fill theme-color-header">{{'public.checkout.total' | translate}}</div>
    <div class="price text-right theme-color-header"
      *ngIf="data.paymentData && data.order.formattedTotalDiscountedPrice; else showNonDiscountedPrice">
      {{data.order.totalDiscountedPrice | formatPrice:
      data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
    </div>
    <ng-template #showNonDiscountedPrice>
      <div class="price text-right theme-color-header">
        {{data.order.totalNonDiscountedPrice | formatPrice:
        data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
      </div>
    </ng-template>

  </div>
  <div class="d-flex flex-column pt-2" *ngIf="isItemSelected()">
    <div class="total flex-fill theme-color-header font-weight-bold mb-2">
      {{'public.standalonepayment.paymentpage.selectedItems' | translate}}</div>
    <ng-container *ngFor="let item of data.order.orderItems; last as isLastItem">
      <div *ngIf="selectedItems[item.uuid]" class="item-wrapper d-flex flex-row mb-2 align-items-baseline"
        [ngClass]="(!shouldDisplayTotal() && isLastItem) ? 'no-border-bottom' : ''">
        <div class="qty" *ngIf="item.hierarchyLevel === 'PARENT'">
          <span>{{selectedItems[item.uuid]}}x</span>
        </div>
        <div class="item flex-fill mb-2 ml-2">
          <div class="p-0 mb-0 item-name">
            <span>{{item.itemName}}</span>
            <span class="text-nowrap" *ngIf="data.paymentData && item.offerPrice && isShowParentItemPrice(item)">(
              {{item.offerPrice | formatPrice:
              data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
              )</span>
          </div>
          <ng-container>
            <div class="item-specs p-0 mb-0" *ngIf="data.paymentData && item.discountValue">
              <span class="discount">{{'public.global.discount' | translate}} (-
                {{item.discountValue | formatPrice:
                data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
                )</span>
              <span class="discount-percentage" *ngIf="item.discountType==='PERCENTILE'">-{{item.discountValue}}%</span>
            </div>
            <div class="item-specs p-0 mb-0" *ngIf="data.paymentData && item.childOrderItems?.length">
              <div *ngFor="let childItem of item.childOrderItems">
                <div>
                  <span class="theme-color-header">
                    {{childItem.quantity > 1 ? childItem.quantity + ' x' : ''}}
                    {{childItem.itemName}}
                  </span>
                  <span *ngIf="childItem.offerPrice">( {{childItem.offerPrice | formatPrice:
                    data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
                    )</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="price text-right font-weight-bold theme-color-header"
          *ngIf="item.hierarchyLevel === 'PARENT' || item.hierarchyLevel === 'RULE'">
          <div *ngIf="data.paymentData">
            {{selectedItems[item.uuid] * calculatePerItemTotalPrice(item) | formatPrice:
            data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
          </div>
        </div>
      </div>
    </ng-container>
    <div class="cart-total-wrapper mb-3 d-flex flex-row font-weight-bold total-val pt-3"
      *ngIf="data.paymentData && shouldDisplayTotal()">
      <div class="total flex-fill theme-color-header">{{'public.standalonepayment.paymentpage.subtotalSelected' |
        translate}}</div>
      <div class="price text-right theme-color-header" *ngIf="data.paymentData">
        {{selectedItemsTotal | formatPrice:
        data.paymentData.locale:data.paymentData.currencyIsoCode:data.paymentData.currencySymbol}}
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="buttonsArea float-right theme-interface">
  <div class="row d-md-flex">
    <div class="col-12 d-flex align-items-end">
      <a type="link" class="cursor-pointer dark text-decoration-underline order-1"
        (click)="onNoClick()">{{'admin.global.cancel'
        | translate}}</a>
      <button type="button" class="button theme-dark dark px-4 ml-4 order-2 ok-btn"
        (click)="save()">{{'public.dialog.ok'|
        translate}}</button>
    </div>
  </div>
</div>